// Claude: Admin Seller FAQ page — manage seller-facing FAQ entries 13-03-2026
import React from "react";
import KnowledgeBasePage from "./KnowledgeBasePage";

const SellerFAQ = () => <KnowledgeBasePage type="seller_faq" title="Seller FAQ" />;

export default SellerFAQ;
